// extracted by mini-css-extract-plugin
export var addToCartButton = "_jn-b";
export var arrowButtonContainer = "_jn-9";
export var arrowButtonIcon = "_jn-a";
export var carouselArrowButton = "_jn-6";
export var carouselElementContainer = "_jn-1";
export var left = "_jn-7";
export var productDisplayCarouselContainer = "_jn-0";
export var productTileContainer = "_jn-2";
export var productTileImage = "_jn-4";
export var productTileImageContainer = "_jn-3";
export var productTileTitle = "_jn-5";
export var right = "_jn-8";
export var sliderOverflow = "_jn-c";